import { Dispatch } from "redux";
import {
  getProjects,
  createProject,
  updateProject,
  deleteProject,
} from "../../services/ProjectService";
import { Project } from "../../types/Project";

// Action Types
export enum ProjectActionType {
  FETCH_PROJECTS = "FETCH_PROJECTS",
  ADD_PROJECT = "ADD_PROJECT",
  EDIT_PROJECT = "EDIT_PROJECT",
  DELETE_PROJECT = "DELETE_PROJECT",
}

// Action Interfaces
export interface FetchProjectsAction {
  type: ProjectActionType.FETCH_PROJECTS;
  data: Project[];
}

export interface AddProjectAction {
  type: ProjectActionType.ADD_PROJECT;
  data: Project;
}

export interface EditProjectAction {
  type: ProjectActionType.EDIT_PROJECT;
  data: Project;
}

export interface DeleteProjectAction {
  type: ProjectActionType.DELETE_PROJECT;
  data: number;
}

export type ProjectAction =
  | FetchProjectsAction
  | AddProjectAction
  | EditProjectAction
  | DeleteProjectAction;

// Thunks
export const fetchProjects = () => async (dispatch: Dispatch) => {
  const data = await getProjects();
  dispatch<FetchProjectsAction>({
    type: ProjectActionType.FETCH_PROJECTS,
    data,
  });
};

export const addProject = (project: Project) => async (dispatch: Dispatch) => {
  const response = await createProject(project);
  dispatch<AddProjectAction>({
    type: ProjectActionType.ADD_PROJECT,
    data: response.data.data,
  });
};

export const editProject =
  (id: number, project: Project) => async (dispatch: Dispatch) => {
    const response = await updateProject(id, project);
    dispatch<EditProjectAction>({
      type: ProjectActionType.EDIT_PROJECT,
      data: response.data.data,
    });
  };

export const deleteProjectById = (id: number) => async (dispatch: Dispatch) => {
  await deleteProject(id);
  dispatch<DeleteProjectAction>({
    type: ProjectActionType.DELETE_PROJECT,
    data: id,
  });
};
